<template>
  <div class="model-generator-form">
    <el-form ref="form" :model="formData" label-width="100px">
      <!-- Product Selection -->
      <el-form-item label="Product" class="form-item">
        <el-select
          v-model="formData.productId"
          placeholder="Select product"
          filterable
          class="wp-100"
        >
          <el-option
            v-for="product in products"
            :key="product.id"
            :label="product.productName"
            :value="product.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <!-- RMSE Input -->
      <el-form-item label="RMSE" class="form-item">
        <el-input-number v-model="formData.rmse" :min="0" :max="100" :step="1">
        </el-input-number>
      </el-form-item>

      <!-- Run Button -->
      <el-button
        @click="handleRun"
        :loading="creating"
        :disabled="!isFormValid || creating"
        type="primary"
        class="run-button"
      >
        {{ creating ? 'CREATING...' : 'RUN' }}
      </el-button>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BackTestApiService from '@/services/BackTestApiService'
import swal from 'sweetalert'
import { jobTypes } from '@/const'

export default {
  name: 'ModelGeneratorForm',
  data() {
    return {
      formData: {
        productId: null,
        rmse: 20
      },
      creating: false
    }
  },
  computed: {
    ...mapState('product', ['products']),
    isFormValid() {
      return this.formData.productId && this.formData.rmse
    }
  },
  mounted() {
    this.loadProducts()
  },
  methods: {
    ...mapActions('product', ['fetchProduct']),
    async loadProducts() {
      await this.fetchProduct()
      if (this.products.length > 0) {
        this.formData.productId = this.products[0].id
      }
    },
    async handleRun() {
      if (!this.isFormValid) {
        swal({
          icon: 'warning',
          title: 'Warning',
          text: 'Please select a product'
        })
        return
      }

      this.creating = true
      try {
        const jobData = {
          jobType: jobTypes.modelGenerator,
          parameters: {
            productId: this.formData.productId,
            rmse: this.formData.rmse
          }
        }

        const response = await BackTestApiService.createBackTest(jobData)

        swal({
          icon: 'success',
          title: 'Success',
          text: 'Job created successfully'
        })

        this.$emit('job-created', response.data.jobId || response.data.Id)
      } catch (error) {
        swal({
          icon: 'error',
          title: 'Error',
          text: 'Failed to create job'
        })
      } finally {
        this.creating = false
      }
    },
    resetForm() {
      this.formData = {
        productId: this.products.length > 0 ? this.products[0].id : null,
        rmse: 20
      }
    }
  }
}
</script>

<style scoped lang="scss">
.model-generator-form {
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;

  /deep/ .el-form {
    margin: 0;

    .el-form-item {
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 8px;
      }
    }
  }

  .run-button {
    width: 100%;
  }
}
</style>
